import React from 'react';
import { LoadingOverlay } from '@/Components/shared';
import { useCompanyContext } from '@/Context/CompanyContext';

const withCompanyProfileRequired = function <T extends React.JSX.IntrinsicAttributes>(
    Component: React.ComponentType<T>,
) {
    return (props: T) => {
        const { isLoading } = useCompanyContext();

        if (isLoading) {
            return <LoadingOverlay />;
        }

        return <Component {...props} />;
    };
};

export default withCompanyProfileRequired;
